module.exports = __webpack_public_path__ + "img/20210828_214202.f8a37d9c.jpg";